import { helper } from "@ember/component/helper";
import { htmlSafe } from "@ember/template";
import BioExamResult from "core/models/bio-exam-result";
function compute([result]) {
  if (!result.unit) return;
  return htmlSafe(result.unit);
}
export default helper(compute);